/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Event_PriceInputs */

const en_cp_p_event_price = /** @type {(inputs: Cp_P_Event_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free for 45 days`)
};

const id_cp_p_event_price = /** @type {(inputs: Cp_P_Event_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis 45 hari`)
};

/**
* | output |
* | --- |
* | "Free for 45 days" |
*
* @param {Cp_P_Event_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_event_price = /** @type {((inputs?: Cp_P_Event_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Event_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_event_price(inputs)
	return en_cp_p_event_price(inputs)
});